// About.js
import React, { useEffect } from 'react';
import { Container, Row, Col } from 'react-bootstrap';

function EcnPage() {
  useEffect(() => {
    document.title = 'FAMA - ECN';
  }, []);
  return (
    <Container className='public-page-container ecn-page'>
      <Row>
        <h1>Equipo Coordinador Nacional</h1>
      </Row>
      <Row className="justify-content-md-center">
        <Col xs={6} md={4} lg={3} className='asesor'>
          <img src='/ecn-pictures/most-rev-arturo-cepeda.jpg' />
          <div className='apostolado'>
            <p className='name'>Rev. Arturo Cepeda</p>
            <p>Representante de FAMA ante la Conferencia de Obispos Católicos de los Estados Unidos</p>
            <p><b>San Antonio, TX</b></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3} className='asesor'>
          <img src='/ecn-pictures/fr-jocob-vanassche.jpg' />
          <div className='apostolado'>
            <p className='name'>Fr. Jacob VanAssche</p>
            <p>Asesor Espiritual Nacional</p>
            <p><b>Pontiac, MI</b></p>
          </div>
        </Col>
      </Row>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/zapopan-gilberto-gonzalez.jpg' />
          <div className='apostolado'>
            <p className='name'>Gilberto y Zapopan González</p>
            <p>Matrimonio Presidente</p>
            <p><b>Laredo, TX</b></p>
            <p><a href='mailto:presidentes@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/andres-carmen-villalon.jpg' />
          <div className='apostolado'>
            <p className='name'>Andres y Carmen Villalon</p>
            <p>Matrimonio Vicepresidente</p>
            <p><b>Cedar Park, TX</b></p>
            <p><a href='mailto:vicepresidentes@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/javier-alma-saldana.jpg' />
          <div className='apostolado'>
            <p className='name'>Javier y Alma Saldaña</p>
            <p>Matrimonio Secretario</p>
            <p><b>Austin, TX</b></p>
            <p><a href='mailto:secretarios@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/luis-cristina-quintanilla.jpg' />
          <div className='apostolado'>
            <p className='name'>Luis y Cristina Quintanilla</p>
            <p>Matrimonio Tesorero</p>
            <p><b>Austin, TX</b></p>
            <p><a href='mailto:tesoreros@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/eduardo-karol-flores.jpg' />
          <div className='apostolado'>
            <p className='name'>Eduardo y Karol Flores</p>
            <p>Matrimonio Coordinador de Tecnología</p>
            <p><b>Frisco, TX</b></p>
            <p><a href='mailto:tecnologia@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/agustin-maria-ramirez.jpg' />
          <div className='apostolado'>
            <p className='name'>Agustín y María Ramírez</p>
            <p>Matrimonio Coordinador Regional 1</p>
            <p><b>Las Vegas, NV</b></p>
            <p><a href='mailto:region1@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/jose-ivan-mireya-duarte.jpg' />
          <div className='apostolado'>
            <p className='name'>José Iván y Mireya Duarte</p>
            <p>Matrimonio Coordinador Regional 2</p>
            <p><b>McKinney, TX</b></p>
            <p><a href='mailto:region2@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/miguel-haydee-garcia.jpeg' />
          <div className='apostolado'>
            <p className='name'>Miguel y Haydee García</p>
            <p>Matrimonio Coordinador Regional 3</p>
            <p><b>Rochester Hills, MI</b></p>
            <p><a href='mailto:region3@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/lupita-flores.jpg' />
          <div className='apostolado'>
            <p className='name'>Guadalupe Flores</p>
            <p>Coordinadora de Madres en Misión Apostólica</p>
            <p><b>Laredo, TX</b></p>
            <p><a href='mailto:madres@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/marcos-raquel.jpg' />
          <div className='apostolado'>
            <p className='name'>Marcos y Raquel González</p>
            <p>Matrimonio Colaborador</p>
            <p><b>La Porte, TX</b></p>
            <p><a href='mailto:colaborador1@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
      </Row>
      <Row className='mt-5 mb-4'>
        <h2>Coordinadores de Servicios Nacionales</h2>
      </Row>
      <Row>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/alejandro-rosalina-leon.jpg' />
          <div className='apostolado'>
            <p className='name'>Alejandro y Rosalina León</p>
            <p>Matrimonio Coordinador de Oración y Liturgia</p>
            <p><b>Las Vegas, NV</b></p>
            <p><a href='mailto:oracion@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/rodolfo-maria-lopez.jpg' />
          <div className='apostolado'>
            <p className='name'>Rodolfo Rey y María del Rosario López</p>
            <p>Matrimonio Coordinador de Capacitación</p>
            <p><b>San Antonio, TX</b></p>
            <p><a href='mailto:capacitacion@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/jose-luis-belma-yepez.jpg' />
          <div className='apostolado'>
            <p className='name'>José Luis y Belma Yépez</p>
            <p>Matrimonio Coordinador de Iosef (Niños)</p>
            <p><b>Calexico, CA</b></p>
            <p><a href='mailto:iosef@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/rafael-alma-vasquez.jpg' />
          <div className='apostolado'>
            <p className='name'>Rafael y Alma Vasquez</p>
            <p>Matrimonio Coordinador de Alianza Martimonioal</p>
            <p><b>Denver, CO</b></p>
            <p><a href='mailto:alianzamatrimonial@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
        <Col xs={6} md={4} lg={3}>
          <img src='/ecn-pictures/alex-maria-guerrero.jpg' />
          <div className='apostolado'>
            <p className='name'>Alberto Alejandro y María Guadalupe Guerrero</p>
            <p>Matrimonio Coordinador de Misión Juvenil</p>
            <p><b>McKinney, TX</b></p>
            <p><a href='mailto:misionjuvenil@familiasenmisionapostolica.org'>Contactar por email</a></p>
          </div>
        </Col>
      </Row>
    </Container>
  );
}

export default EcnPage;
